import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useEffect } from 'react';
import { API } from '../constants/constants';

import Axios from 'axios';
import authClient from '../auth/Auth';

const useStyles = makeStyles({
    list: {
        width: 500,
    },
    upload: {
        color: '#FFFFFF'
    }
});

export default function UploadedImages(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [isLoading, setLoading] = React.useState(false);
    const [images, setImages] = React.useState({
        externalData: []
    })

    const toggleDrawer = (isOpen) => event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpen(isOpen);
    };

    useEffect(() => {
        if (open === true) {
            loadImages();
        }
    }, [open]);

    function loadImages() {
        setLoading(true);
        Axios.get(
            props.isStaging ? API.staging.uploadedFiles : API.production.uploadedFiles,
            {
                params: {
                    filesCount: 20
                },
                headers: {
                    'x-access-token': authClient.getIdToken(),
                }
            }
        ).then(response => {
            if (response && response.data && response.data.data) {
                setImages({ externalData: response.data.data });
            } else {
                alert("Unknown error");
            }
        })
            .catch(function (error) {
                console.log(error);
                alert(error);
            })
            .then(function () {
                // always executed
                console.log("call finished");
                setLoading(false);
            });
    }

    const displayImages = () => {
        return (images.externalData.map(img => (
            <GridListTile key={img} cols={1}>
                <img src={img} alt="" onClick={(e) => { props.selectedImage(e.target.src) }} />
            </GridListTile>
        )));
    }

    const sideList = () => (
        <div
            className={classes.list}
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}>
            {isLoading && [<Divider />, <LinearProgress />, <Divider />]}
            <GridList cellHeight={160} cols={3}>
                {displayImages()}
            </GridList>
        </div>
    );

    return (
        <div>
            <Button className={classes.upload} onClick={toggleDrawer(true)}>Preview uploaded images</Button>
            <Drawer open={open} onClose={toggleDrawer(false)}>
                {sideList()}
            </Drawer>
        </div>
    );
}